import { AuthService } from '@app/shared/common/IDSVRAuthProviders/auth.service';
import { AppConsts } from '@shared/AppConsts';
import { XmlHttpRequestHelper } from '@shared/helpers/XmlHttpRequestHelper';
import * as moment from 'moment';
import { HttpMethodBaseService } from './HttpMethodsBase/httpmethods-base';
import { HttpHeaders } from '@angular/common/http';
var QuoteStatusService = /** @class */ (function () {
    function QuoteStatusService(_authService, httpMethodBaseService) {
        this._authService = _authService;
        this.httpMethodBaseService = httpMethodBaseService;
        this.API_BASE_URL_IDP = abp.setting.values['PortalSettings.authority'];
    }
    QuoteStatusService.prototype.updateQuoteStatus = function (quoteGuids, brokerGuid, status, isApproved, coverReason, businessAssuranceType, policyHolderIsInsuredLife, primaryQuoteGuid, lifeInsuredId, initialQuircStatus, wasInitiallyReferred) {
        if (isApproved === void 0) { isApproved = false; }
        if (coverReason === void 0) { coverReason = null; }
        if (businessAssuranceType === void 0) { businessAssuranceType = null; }
        if (policyHolderIsInsuredLife === void 0) { policyHolderIsInsuredLife = null; }
        if (primaryQuoteGuid === void 0) { primaryQuoteGuid = null; }
        if (lifeInsuredId === void 0) { lifeInsuredId = null; }
        if (initialQuircStatus === void 0) { initialQuircStatus = null; }
        if (wasInitiallyReferred === void 0) { wasInitiallyReferred = null; }
        var _a;
        var customHeaders = (_a = {},
            _a[abp.multiTenancy.tenantIdCookieName] = abp.multiTenancy.getTenantIdCookie(),
            _a['Authorization'] = 'Bearer ' + abp.auth.getToken(),
            _a);
        var data = {
            'quoteGuids': quoteGuids,
            'status': status,
            'timeStamp': moment(),
            'isApproved': isApproved,
            'accessToken': this._authService.user.access_token,
            'brokerGuid': brokerGuid,
            'coverReason': coverReason,
            'businessAssuranceType': businessAssuranceType,
            'policyHolderIsInsuredLife': policyHolderIsInsuredLife,
            'currentUserGuid': this._authService.user.profile.sub,
            'primaryQuoteGuid': primaryQuoteGuid,
            'lifeInsuredid': lifeInsuredId,
            'initialQuircStatus': initialQuircStatus,
            'wasInitiallyReferred': wasInitiallyReferred,
        };
        XmlHttpRequestHelper.ajax('PUT', AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/UpdateQuoteStatus', customHeaders, JSON.stringify(data), function (result) {
            console.log('updateQuoteStatus', result);
        });
    };
    QuoteStatusService.prototype.pushMessages = function (quoteGuids, brokerGuid, status, isApproved, coverReason, businessAssuranceType, policyHolderIsInsuredLife) {
        if (isApproved === void 0) { isApproved = false; }
        if (coverReason === void 0) { coverReason = null; }
        if (businessAssuranceType === void 0) { businessAssuranceType = null; }
        if (policyHolderIsInsuredLife === void 0) { policyHolderIsInsuredLife = null; }
        var data = {
            'quoteGuids': quoteGuids,
            'status': status,
            'timeStamp': moment(),
            'isApproved': isApproved,
            'accessToken': this._authService.user.access_token,
            'brokerGuid': brokerGuid,
            'coverReason': coverReason,
            'businessAssuranceType': businessAssuranceType,
            'policyHolderIsInsuredLife': policyHolderIsInsuredLife,
        };
        this.httpMethodBaseService.post(AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/PushMessages', JSON.stringify(data), new HttpHeaders({ 'Content-Type': 'application/json' }))
            .pipe((function (res) {
            return res;
        })).subscribe(function (result) { });
    };
    return QuoteStatusService;
}());
export { QuoteStatusService };
